import React from "react";

import Header from "../components/header";
import DividerBottom from "../components/divider-bottom";
import Footer from "../components/footer";

import BeaverLogo from "../assets/images/beavers_logo.png";
import BeaverUniform from "../assets/images/beavers-uniform.png";
import BeaverBadgePlacement from "../assets/images/beavers-badge-placement.png";

function Beavers() {
    return (
        <>
            <Header />

            <main id="beavers">
                <div className="sections-container">
                    <div className="section-item">
                        <img src={BeaverLogo} alt="Beavers"></img>
                        <p>6 - 8 Years</p>
                        <p>Term-time Tuesdays 4:45 - 6:00pm</p>
                    </div>
                </div>
                
                <section id="section-details">
                    <section id="about-section">
                        <h1>About Beavers</h1>
                        <ul>
                            <li>At the 17th, Beavers are our youngest members, and generally meet for an hour and a quarter per week.</li>
                            <li>Beavers are young children, aged between six and eight years old.</li>
                            <li>During their time at the 17th, Beavers get to enjoy all that Scouting has to offer; being introduced to outdoor activities, having the opportunity to be creative, explore their local community and experience the excitement of Beaver Sleepover with their friends.</li>
                            <li>Scouting believes that the best way for children to learn is to get involved and get their hands dirty, learning through exploring, playing and doing.</li>
                        </ul>
                    </section>
                    <section id="leaders-section">
                        <h1>Who runs the section?</h1>
                        <p>The Beaver colony at the 17th is run by a team of hardworking volunteers, who dedicate their time to making sure your children experience the best that Scouting has to offer.</p>
                        <ul>
                            <li>Section Leader: Arun</li>
                            <li>Assistant Section Leader: Hawkeye</li>
                            <li>Assistant Section Leader: Windrush</li>
                            <li>Assistant Section Leader: Riverflow</li>
                            <li>Young Leader: Bear</li>
                            <li>Young Leader: Piston</li>
                        </ul>
                    </section>
                    <section id="promise-section">
                        <h1>The Beaver Promise</h1>
                        <ul>
                            <li>I promise to do my best</li>
                            <li>To be kind and helpful</li>
                            <li>And to love God</li>
                        </ul>
                    </section> 
                </section>
                
                <section id="uniform-info">
                    <h1>Uniform and Badges</h1>
                    <div className="uniform-info-container">
                        <div className="uniform-info-item">
                            <h3>What Beavers wear</h3>
                            <p>Beaver Scouts wear a turquoise sweatshirt, our group t-shirt and a neckerchief tied with a coloured woggle denoting which riverbank they are a part of. They also wear navy blue activity trousers or shorts, and suitable, sturdy footwear.</p>
                        </div>
                        <div className="uniform-info-item">
                            <h3>Why uniform is important</h3>
                            <p>Wearing a uniform is comfy and practical and means you can run around and get messy without ruining your other clothes. It makes you feel part of a team and means no one feels uncomfortable or left out. It also gives you a place to show off all the brilliant badges you earn.</p>
                        </div>
                        <div className="uniform-info-item">
                            <h3>Where you can buy the uniform</h3>
                            <p>Uniform can either be bought from the online Scout Association shop - <a href="https://shop.scouts.org.uk/" target="_blank">Scout Store</a> - or from a local supplier such as the Butchers Coppice Scout shop or some school uniform shops. If you're stuck, ask us to tell you more about what to buy and where to buy it. If cost is an issue, we may have some second-hand kit available.</p>
                        </div>
                    </div>
                </section>
                
                <section id="uniform-images">
                    <div className="uniform-images-container">
                        <img src={BeaverUniform} alt="Beaver Uniform Diagram"></img>
                        <img src={BeaverBadgePlacement} alt="Beavers Badge Placement Diagram"></img>
                    </div> 
                </section>
            <DividerBottom />
            </main>
            <Footer />
        </>
    );
}

export default Beavers;